export const ErrorState = {
  image: '/icons/not-found.png',
  sufix: '',
  linkText: '404.Prefix_link_text',
  text: '404Page.Upset_text',
  items: [
    {
      icon: '/icons/folder-plus.svg',
      title: 'Documentation',
      link: '/',
      width: 32,
      height: 32,
      type: 'link',
    },
    {
      icon: '/icons/envelope.svg',
      title: 'Contact Us',
      link: '/contact-us',
      width: 32,
      height: 32,
      type: 'link',
    },
  ],
};

export interface IErrorPageButtons {
  icon: string;
  title: string;
  link: string;
  width: number;
  height: number;
  type: string;
}

export interface IErrorState {
  image: string;
  text: string;
  sufix: string;
  linkText: string;
  items: Array<IErrorPageButtons>;
}
